// @ts-nocheck -- if you need to modify this file, you MUST remove this directive and fix all type errors before making any changes
import * as Sentry from "@sentry/react";

/**
 * Browser errors that are not actionable and should be dropped.
 */
export function shouldDropEvent(exception: unknown): boolean {
  if (!exception) return false;
  const msg = (exception as any).message || String(exception);
  const name = (exception as any).name || "";

  // Video play/pause race conditions (AbortError from media APIs)
  if (msg.includes("play() request was interrupted")) return true;

  // Generic AbortError (navigation, fetch abort, etc.)
  if (name === "AbortError") return true;

  // Autoplay blocked by browser policy
  if (name === "NotAllowedError") return true;

  // Video element with no playable source format (native or wrapped in Error)
  if (name === "NotSupportedError" || msg.includes("NotSupportedError"))
    return true;

  // Google Translate / browser extensions manipulating React DOM
  if (
    (msg.includes("insertBefore") || msg.includes("removeChild")) &&
    msg.includes("not a child of this node")
  )
    return true;

  return false;
}

// todo: https://docs.sentry.io/platforms/javascript/guides/react/#react-19-error-reporting
if (
  import.meta.env.VITE_ENVIRONMENT &&
  !import.meta.env.VITE_REACT_SUPPRESS_SENTRY
) {
  Sentry.init({
    dsn: "https://99b46a3a1969aca19dbad17dff15a007@o4506519499309056.ingest.us.sentry.io/4507435565056000",
    integrations: [
      // Sentry.replayIntegration(),
      // Sentry.feedbackIntegration({
      //   // Additional SDK configuration goes in here, for example:
      //   colorScheme: "system",
      // }),
    ],
    // Exceptions filtering
    beforeSend(event, hint) {
      if (shouldDropEvent(hint.originalException)) {
        return null;
      }
      if (
        hint.originalException instanceof DataCloneError &&
        hint.originalException.message.includes("The object can not be cloned.")
      ) {
        return null;
      }
      return event;
    },
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.3,
    environment: import.meta.env.VITE_ENVIRONMENT,
  });
}

class DataCloneError extends Error {
  constructor(message) {
    super(message);
    this.name = "DataCloneError";
  }
}
